<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent min-width="290" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> {{ title }} </v-card-title>
        <v-card-text> {{ message }} </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="onSim"> Sim </v-btn>
          <v-btn text @click="onNao"> Não </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      title: null,
      message: null,
      resolve: null,
      reject: null,
    };
  },

  methods: {
    show(title, message) {
      this.title = title;
      this.message = message;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    onSim() {
      this.resolve(true);
      this.dialog = false;
    },
    
    onNao() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>
